module.exports = __webpack_public_path__ + "img/selected_checkin_at_airport.214deb5b.svg";